export var ENTITY = "property-amenity";
export var REDUCER_KEY = "PROPERTY_AMENITY_V2";
export var BASE_PATH_ENTITY = "property-amenities";
export var GENERATOR_PARAMS = {
    entity: ENTITY,
    reducerKey: REDUCER_KEY,
    basePathEntity: BASE_PATH_ENTITY,
    defaultSort: [],
};
